import Sidemenu from "../../layout/sidemenu";
import Header from "../../layout/header";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from "react-router";
import { useState,useEffect } from "react";
import { NoAuthApiRequest,ApiRequest } from "../services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../../utils/endpoints";
import { Formik } from 'formik';
import AssignUser from "../assign-user";
import { ToastContainer, toast } from "react-toastify";
import React, { useRef } from 'react';
import Swal from "sweetalert2";
import  Loader from '../shared/loader'

const DailyTimesheet = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [loader,setloader]=useState(false);
     const navigate = useNavigate();
    const [lstProject,setlstProject]= useState([]);
    const [lstCategory,setlstCategory]= useState([]);
    const [dailyTotal,setdailyTotal] =useState(0);
    const[lstTimesheet,setlstTimesheet] = useState([]);
     
    const[txtBillable,settxtBillable]=useState('');
    const[txtNonBillable,settxtNonBillable]=useState('');
    const[txtNoCharge,settxtNoCharge]=useState('');
         const [formData, setFormData] = useState({
            TimeSheetDate: '',
            ProjectId:-1,
            Title: '',
            Description:'',
            Billable:0,
            NonBillable:0,
            NoCharge:0,
            CategoryId:-1,
            Id:0,
            CreatedBy:'',
            UserId:-1
         });

           const [currentPage, setCurrentPage] = useState(1);
                  const [pageSize, setPageSize] = useState(50); // Default page size
                  const [totalPages, setTotalPages] = useState(0);
             
                  const [startCount, setstartCount] = useState("");
                  const [endCount, setendCount] = useState("");
                  const [totalCount, settotalCount] = useState("");

     
                  useEffect(() => {
                      const fetchData = async () => {
                        setloader(true);
                        await FetchProject();
                        
                        await FetchCategory();
                                    var currentDate=new Date();
                                    var year = currentDate.getFullYear();
                                    var month = ("0" + (currentDate.getMonth() + 1)).slice(-2); // Adding leading zero if month is single digit
                                    var date =("0" + (currentDate.getDate())).slice(-2); 

                                    handleChangeTigger('TimeSheetDate',year+"-"+month+"-"+date);
                                  
                                   await fetchTimeSheetList();
                                   await FetchDailyTotal(year+"-"+month+"-"+date);
                                 };
                                 fetchData();
                         
                   },[]);

                   const handleChange = async (e) => {
                    const { name, value } = e.target;
                    setFormData((prevState) => ({
                        ...prevState,
                        [name]: value
                    }));
                    if(name=="TimeSheetDate"){
                        await fetchTimeSheet(1,pageSize,value);
                        await FetchDailyTotal(value);
                    }
                };

                const handleChangeTigger = (name, value) => {
                              setFormData((prevState) => ({
                               ...prevState,
                               [name]: value,
                             }));
                       };

const FetchProject = async () => {

    const usrDetails = JSON.parse(localStorage.getItem("user"));
        const data = await ApiRequest(
            ApiEndpoints.Entity.FetchProjectByUser(usrDetails.Id),
            ApiEndpointMethod.Get,
            null,
            navigate
          );
          setlstProject(data);
    };

    const FetchCategory = async () => {

       
            const data = await ApiRequest(
                ApiEndpoints.Entity.FetchCategory,
                ApiEndpointMethod.Get,
                null,
                navigate
              );
              setlstCategory(data);
        };

    const FetchDailyTotal= async (value) => {

        const usrDetails = JSON.parse(localStorage.getItem("user"));
            const data = await ApiRequest(
                ApiEndpoints.TimeSheet.DailyTotalHours(usrDetails.Id,value),
                ApiEndpointMethod.Get,
                null,
                navigate
              );
              setdailyTotal(data.Item1);
        };

    // const FetchTimeEntry = async () => {

    //     const usrDetails = JSON.parse(localStorage.getItem("user"));
    //         const data = await ApiRequest(
    //             ApiEndpoints.Entity.FetchProjectByUser(usrDetails.Id),
    //             ApiEndpointMethod.Get,
    //             null,
    //             navigate
    //           );
    //           setlstProject(data);
    //     };

    const fetchTimeSheetList = async()=>{
        await fetchTimeSheet(1,pageSize);
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchTimeSheet(page, pageSize);
    };

    const getPageNumbers = () => {
        // Dynamically generate page numbers
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
        let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages
      
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
      };
        
                const fetchTimeSheet= async (page, limit,value='') => {
                     
                    try {
                        setloader(true);
                       // setLoader(true);
                       const usrDetails = JSON.parse(localStorage.getItem("user"));
       
                        const data = await ApiRequest(ApiEndpoints.TimeSheet.FetchDailyTimeEntry(usrDetails.Id,page, limit,(value==''?formData.TimeSheetDate:value)), ApiEndpointMethod.Post, null, navigate);
                        
                        
                        await setlstTimesheet(data.Item1);
                        const totalPages = Math.ceil(data.Item2 / limit);
                        setTotalPages(totalPages);
            
                        const startcount = Math.ceil(
                            Math.ceil(Math.ceil(page * limit) - limit) + 1
                        );
                        let endcount = Math.ceil(page * limit);
                        if (endcount > data.Item2) {
                            endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
                        }
                        setstartCount(startcount);
                        setendCount(endcount);
                        settotalCount(data.Item2);
            
                        return { data };
                        // Handle the response data here (e.g., show success message or update UI)
                    } catch (error) {
                        console.error("Error during API call:", error);
                        // await setfileList([]);
                        // Handle errors (e.g., show an error message to the user)
                    }
                    finally {
                     ///   setLoader(false);
                     setloader(false);
                    }
                };

                const clear = (state) =>{
                   
                    if(state==false){
                        handleChangeTigger('TimeSheetDate','');
                        handleChangeTigger('ProjectId',-1,);
                        handleChangeTigger('Title', '');
                        handleChangeTigger('CategoryId',-1);
                    }
          
            handleChangeTigger('Description','');
            handleChangeTigger('Billable',0);
            handleChangeTigger('NonBillable',0);
            handleChangeTigger('NoCharge',0);
          
            handleChangeTigger('Id',0);
            handleChangeTigger('CreatedBy','');
            handleChangeTigger('UserId',-1);
            settxtBillable('');
            settxtNoCharge('');
            settxtNonBillable('');
                }

                const clearformData = async() =>{
                   await clear(false);
                }

                const Validation = async () =>{
                    var objvalid =true;
                        if(formData.TimeSheetDate=="" || formData.TimeSheetDate==null|| formData.TimeSheetDate==undefined){
                            toast.error("Please choose the date", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else if(formData.ProjectId==-1){
                            toast.error("Please choose project", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else if(formData.Title=="" || formData.Title==null|| formData.Title==undefined){
                            toast.error("Please provide the Title", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else if(formData.Description=="" || formData.Description==null|| formData.Description==undefined){
                            toast.error("Please provide the detail Description", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else if(formData.CategoryId==-1){// || formData.Description==null|| formData.Description==undefined){
                            toast.error("Please choose the category", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else if(formData.Billable==0 && formData.NonBillable==0 && formData.NoCharge==0){
                            toast.error("Please provide the hours spend either billable or Non billable else No charge", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            objvalid=false;
                        }
                        else{

                        var arrayvalue=[];
                       // var IsValueenter=false;
                        if(formData.Billable>0){
                            arrayvalue.push(formData.NonBillable);
                            //IsValueenter=true;
                        }
                       // var IsValueenterNonBillable=false;
                        if(formData.NonBillable>0){
                            arrayvalue.push(formData.NonBillable);
                            // if(IsValueenter==true){
                            //     toast.error("Please specify the hours spent as either billable or non-billable; otherwise, there will be no charge.", {
                            //         position: "top-right",
                            //         autoClose: 3000,
                            //         hideProgressBar: false,
                            //         closeOnClick: true,
                            //         pauseOnHover: true,
                            //         draggable: true,
                            //         progress: undefined,
                            //         theme: "light",
                            //     });
                            //     objvalid=false;
                            // }
                            // IsValueenterNonBillable=true;
                        }
                        if(formData.NoCharge>0){
                            arrayvalue.push(formData.NoCharge);
                            // if(IsValueenter ==false && IsValueenterNonBillable==true){
                            //     toast.error("Please specify the hours spent as either billable or non-billable; otherwise, there will be no charge.", {
                            //         position: "top-right",
                            //         autoClose: 3000,
                            //         hideProgressBar: false,
                            //         closeOnClick: true,
                            //         pauseOnHover: true,
                            //         draggable: true,
                            //         progress: undefined,
                            //         theme: "light",
                            //     });
                            //     objvalid=false;
                            // }
                            // IsValueenter=true;
                        }
                        if(arrayvalue.length>1){
                            toast.error("Please specify the hours spent as either billable or non-billable; otherwise, there will be no charge.", {
                               position: "top-right",
                               autoClose: 3000,
                               hideProgressBar: false,
                               closeOnClick: true,
                               pauseOnHover: true,
                               draggable: true,
                               progress: undefined,
                               theme: "light",
                             });
                             objvalid=false;
                             
                        }
                    }

                        return objvalid;
                }

                const EditTimeSheet = async(TimeSheetId) => {
                    setloader(true);
                    const data = await ApiRequest(ApiEndpoints.TimeSheet.EditTimeSheet(TimeSheetId), ApiEndpointMethod.Get, null,navigate);
                    if(data != null){
                        handleChangeTigger('TimeSheetDate',data.TimeSheetDate.split('T')[0]);
                        handleChangeTigger('ProjectId',data.ProjectId);
                        handleChangeTigger('Title', data.Title);
                        handleChangeTigger('Description',data.Description);
                        handleChangeTigger('Billable',data.Billable);
                         handleChangeTigger('NonBillable',data.NonBillable);
                        handleChangeTigger('NoCharge',data.NoCharge);
                        handleChangeTigger('CategoryId',data.CategoryId);
                        handleChangeTigger('Id',data.Id);
                        handleChangeTigger('CreatedBy',data.CreatedBy);
                        handleChangeTigger('UserId',data.UserId);
                        convertDecimalToTime(data.Billable,'Billable');
                        convertDecimalToTime(data.NoCharge,'NoCharge');
                        convertDecimalToTime(data.NonBillable,'NonBillable');
                        setloader(false);
                    }
                }

                const DeleteTimeEntry = async(TimeSheetId) => {
                    const result = await Swal.fire({
                        title: '',
                        text:  "Are you sure want to delete the time entry?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        reverseButtons: true,
                      });
                      if (result.isConfirmed) {
                        setloader(true);
                        const data = await ApiRequest(ApiEndpoints.TimeSheet.DeleteTimeEntry(TimeSheetId), ApiEndpointMethod.Get, null,navigate);
                        if(data != null){
                            await clear(false);
                                         toast.success("Time entry deleted successful", {
                                             position: "top-right",
                                             autoClose: 3000,
                                             hideProgressBar: false,
                                             closeOnClick: true,
                                             pauseOnHover: true,
                                             draggable: true,
                                             progress: undefined,
                                             theme: "light",
                                         });
                                         fetchTimeSheet(currentPage, pageSize);
                                         await FetchDailyTotal(formData.TimeSheetDate);
                        }
                        setloader(false);
                      }
                }



 const CreateTimeSheet = async () => {
    try{
       
        var objvalid =  await Validation();
        if(objvalid==true){
            setloader(true);
            debugger
            if(formData.Billable==""){
                formData.Billable=0;
            }
            if(formData.NonBillable==""){
                formData.NonBillable=0;
            }
            if(formData.NoCharge==""){
                formData.NoCharge=0;
            }
            
        const usrDetails = JSON.parse(localStorage.getItem("user"));
        formData.UserId=usrDetails.Id;
          const data = await ApiRequest(ApiEndpoints.TimeSheet.CreateTimeEntry, ApiEndpointMethod.Post, formData,navigate);
     
        if(data.success==true){
            await clear(true);
                                         toast.success(data.message, {
                                             position: "top-right",
                                             autoClose: 3000,
                                             hideProgressBar: false,
                                             closeOnClick: true,
                                             pauseOnHover: true,
                                             draggable: true,
                                             progress: undefined,
                                             theme: "light",
                                         });
                                         fetchTimeSheet(currentPage, pageSize);
                                         await FetchDailyTotal(formData.TimeSheetDate);
                                     }
                                     else{
                                       
                                        await clear(false);
                                         toast.error(data.message, {
                                             position: "top-right",
                                             autoClose: 3000,
                                             hideProgressBar: false,
                                             closeOnClick: true,
                                             pauseOnHover: true,
                                             draggable: true,
                                             progress: undefined,
                                             theme: "light",
                                         });
                                     }
        }

    } catch (error) {
                    // Handle network errors or any other errors
                    console.error("There was an error sending the form data", error);
                    toast.success(error, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                finally {
                    setloader(false);
                }
   };

   const convertDecimalToTime = (decimalValue,type) => {
    debugger;
    const hours = Math.floor(decimalValue); // Extract whole hours
    const minutes = Math.round((decimalValue - hours) * 60); // Convert decimal to minutes
    if(type=="Billable"){
        if(hours==0 && minutes==0){
            settxtBillable('');
        }
        else{
         settxtBillable(`Time entered: ${('0'+hours).slice(-2)}:${('0'+minutes).slice(-2)}`);
        }
    }
    else  if(type=="NonBillable"){
        if(hours==0 && minutes==0){
            settxtNonBillable('');
        }
        else{
        settxtNonBillable(`Time entered: ${('0'+hours).slice(-2)}:${('0'+minutes).slice(-2)}`);
        }
       }
       else  if(type=="NoCharge"){
        if(hours==0 && minutes==0){
            settxtNoCharge('');
        }
        else{
        settxtNoCharge(`Time entered: ${('0'+hours).slice(-2)}:${('0'+minutes).slice(-2)}`);
        }
       }
  };
    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 me-2">Daily Timesheet</h5>
                                <div className="heading-badge"><small>Total Hours:</small>{dailyTotal} Hrs</div>
                            </div>
                            <div className="d-flex align-items-center">

                                <div className="dropdown">
                                    <button className="btn btn-sm btn-outline-info dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fas fa-file-export me-1"></i>Export
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href="#">Excel</a></li>
                                        <li><a className="dropdown-item" href="#">PDF</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="border bg-white p-3 mb-2">
                             {/* <Formik
                                                                enableReinitialize={true}
                                                                initialValues={formData}
                                                                onSubmit={(values, actions) => {
                                                                    CreateTimeSheet(values);
                                                                }}
                                                            >
                                                                {({
                                                                    values,
                                                                    errors,
                                                                    touched,
                                                                    handleChange1,
                                                                    handleBlur,
                                                                    handleSubmit,
                                                                    setFieldValue,
                                                                    setTouched,
                                                                    validateForm,
                                                                }) => (
                                                                    <form> */}
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="row mb-3">
                                        <div className="col-lg-4">
                                            <label>Date</label>
                                            <input className="form-control" type="date" value={formData?.TimeSheetDate} 
                                             name="TimeSheetDate"
                                             onChange={(e)=>{handleChange(e);}}/>
                                        </div>
                                        <div className="col-lg-4">
                                            <label>Project Name</label>
                                            <select className="form-control" value={formData?.ProjectId} name="ProjectId"  onChange={handleChange}
                                             >
                                                <option value="-1">--Select--</option>
                                                {lstProject?.map((proj) => (
                                                    <option value={proj.Id}>
                                                            {proj.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-lg-4">
                                            <label>Task Title</label>
                                            <input className="form-control" type="text" value={formData?.Title}
                                            name="Title"
                                            onChange={handleChange}
                                            onInput = {(e) =>{
                                                e.target.value = e.target.value.toString().slice(0,150)
                                            }}/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label>Category</label>
                                            <select className="form-control" value={formData?.CategoryId}
                                               name="CategoryId"
                                               onChange={handleChange}>
                                                <option value={-1}>--Select--</option>
                                                {lstCategory?.map((proj) => (
                                                    <option value={proj.Id}>
                                                            {proj.Name}
                                                    </option>
                                                ))}
                                                {/* <option value={1}>Analysis</option>
                                                <option value={2}>Design</option>
                                                <option value={3}>Development</option>
                                                <option value={4}>Documentation</option>
                                                <option value={5}>Learning</option>
                                                <option value={6}>Leave</option>
                                                <option value={7}>Meeting</option>
                                                <option value={8}>Permission</option>
                                                <option value={9}>Project Management</option>
                                                <option value={10}>Testing</option> */}
                                            </select>
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Billable Hours</label>
                                            <div className="input-group">
                                                <input className="form-control" type="number"
                                                 name="Billable" value={formData?.Billable}
                                                 onChange={handleChange}
                                                  onInput = {(e) =>{
                                                    debugger;
                                                    let value = Number(e.target.value);
                                                    if (value > 2) {
                                                        e.target.value = 2;  // Set the value to 2 if it exceeds
                                                      }
                                                      else if(value< 0){
                                                        e.target.value=0;
                                                      }
                                                      convertDecimalToTime(e.target.value,"Billable");
                                                }}/>
                                                {/* <select className="form-control" value={formData?.Billable}
                                                  name="Billable"
                                                  onChange={handleChange}>
                                                    <option value={0}>--select--</option>
                                                    <option value={0.15}>0:15</option>
                                                    <option value={0.30}>0:30</option>
                                                    <option value={0.45}>0:45</option>
                                                    <option value={1.00}>1:00</option>
                                                    <option value={1.15}>1:15</option>
                                                    <option value={1.30}>1:30</option>
                                                    <option value={1.45}>1:45</option>
                                                    <option value={2.0}>2:00</option>
                                                </select> */}
                                                <div className="input-group-text"><i className="far fa-clock"></i></div>
                                            </div>
                                            <span style={{color:"green",fontWeight:"500"}}>{txtBillable}</span>
                                        </div>
                                        <div className="col-lg-4 mb-2">
                                            <label>Non Billable Hours</label>
                                            <div className="input-group">
                                            <input className="form-control" type="number"
                                                 name="NonBillable"
                                                 value={formData?.NonBillable}
                                                 onChange={handleChange}
                                                  onInput = {(e) =>{
                                                    let value = Number(e.target.value);
                                                    if (value > 2) {
                                                        e.target.value = 2;  // Set the value to 2 if it exceeds
                                                      }
                                                      else if(value<0){
                                                        e.target.value=0;
                                                      }
                                                      convertDecimalToTime(e.target.value,"NonBillable");
                                                }}/>
                                                {/* <select className="form-control" value={formData?.NonBillable}
                                                 name="NonBillable"
                                                 onChange={handleChange}
                                               >
                                                    <option value={0}>--select--</option>
                                                    <option value={0.15}>0:15</option>
                                                    <option value={0.30}>0:30</option>
                                                    <option value={0.45}>0:45</option>
                                                    <option value={1.00}>1:00</option>
                                                    <option value={1.15}>1:15</option>
                                                    <option value={1.30}>1:30</option>
                                                    <option value={1.45}>1:45</option>
                                                    <option value={2.0}>2:00</option>
                                                </select> */}
                                                <div className="input-group-text"><i className="far fa-clock"></i></div>
                                            </div>
                                            <span style={{color:"green",fontWeight:"500"}}>{txtNonBillable}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label>No Charge Hours</label>
                                            <div className="input-group">
                                            <input className="form-control" type="number"
                                                 name="NoCharge" value={formData?.NoCharge}
                                                 onChange={handleChange}
                                                  onInput = {(e) =>{
                                                    let value = Number(e.target.value);
                                                    
                                                    if(formData?.CategoryId==6){

                                                        if(value ==4 || value == 8){
                                                           
                                                        }
                                                        else if(value<0){
                                                            e.target.value = 0;
                                                        }
                                                        else{
                                                            e.target.value = '';
                                                        }
                                                    }
                                                    else{
                                                    if (value > 2) {
                                                        e.target.value = 2;  // Set the value to 2 if it exceeds
                                                      }
                                                    }
                                                    convertDecimalToTime(e.target.value,"NoCharge");
                                                
                                                }}/>
                                                {/* <select className="form-control" value={formData?.NoCharge}
                                                     name="NoCharge"
                                                     onChange={handleChange}
                                                   
                                                >
                                                    <option value={0}>--select--</option>
                                                    {formData?.CategoryId==6 ? (
                                                        <>
                                                          <option value={4.00}>4:00</option>
                                                          <option value={8.00}>8:00</option>
                                                        </>
                                                    ):
                                                    (
                                                    <>
                                                    <option value={0.15}>0:15</option>
                                                    <option value={0.30}>0:30</option>
                                                    <option value={0.45}>0:45</option>
                                                    <option value={1.00}>1:00</option>
                                                    <option value={1.15}>1:15</option>
                                                    <option value={1.30}>1:30</option>
                                                    <option value={1.45}>1:45</option>
                                                    <option value={2.0}>2:00</option>
                                                    </>
                                                    )
                                                }
                                                    
                                                </select> */}
                                                <div className="input-group-text"><i className="far fa-clock"></i></div>
                                            </div>
                                            <span style={{color:"green",fontWeight:"500"}}>{txtNoCharge}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-5">
                                    <div className="form-group">
                                        <label>Task</label>
                                        <textarea className="form-control" rows={5}  name="Description"
                                         onInput = {(e) =>{
                                            e.target.value = e.target.value.toString().slice(0,1500)
                                        }}
                                                     onChange={handleChange}
                                                     value={formData?.Description}></textarea>
                                    </div>
                                    <div className="text-end">
                                        <button className="btn btn-sm btn-outline-info me-2" onClick={()=>clearformData()}>
                                            <i className="fas fa-times me-1"></i>Cancel
                                        </button>
                                        <button className="btn btn-sm btn-info" onClick={() => CreateTimeSheet()}>
                                            <i className="fas fa-check me-1"></i>Save
                                        </button>
                                    </div>
                                </div>

                            </div>
                               {/* </form>
                                                         )}
                                                         </Formik> */}

                        </div>

                        <div className="table-wrapper daily-table">
                            <table className="table table-striped table-bordered bg-white align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th width="13%">Project Name</th>
                                        <th width="10%">Category</th>
                                        <th width="9%" className="text-center">Billable Hours</th>
                                        <th width="9%" className="text-center">Non Billable Hours</th>
                                        <th width="9%" className="text-center">No Charge Hours</th>
                                        <th width="12%">Task Title</th>
                                        <th width="30%">Description</th>
                                        <th width="8%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {lstTimesheet?.map((time) => (
                                    <tr>
                                        <td>
                                            <div>{time.Project}</div>
                                            <small className="fst-italic text-muted">{time.Client}</small>
                                        </td>
                                        <td>{time.Category}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.Billable}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.NonBillable}</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>{time.NoCharge}</td>
                                        <td>{time.Title}</td>
                                        <td> <span className="text-ellipsis">{time.Description}</span></td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit" onClick={()=>EditTimeSheet(time.Id)}>
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete" onClick={()=>DeleteTimeEntry(time.Id)}>
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                ))}
                                    {/* <tr>
                                        <td>
                                            <div>Amalga</div>
                                            <small className="fst-italic text-muted">Kevin M. Dorey</small>
                                        </td>
                                        <td>Development</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td className="text-center">
                                            <i className="far fa-clock me-1"></i>2:00</td>
                                        <td></td>
                                        <td></td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                        <div className="pagination-wrapper shadow-sm">
                               <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                               <ul className="pagination">
                                   <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                           <i className="fa-solid fa-chevron-left"></i>
                                       </a>
                                   </li>

                                   {getPageNumbers().map((page) => (
                                       <li key={page} >
                                           <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                               {page}
                                           </a>
                                       </li>
                                   ))}

                                   <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                           <i className="fa-solid fa-chevron-right"></i>
                                       </a>
                                   </li>
                               </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" style={{ zIndex: 9999 }} />
            <Tooltip id="deleteTooltip" style={{ zIndex: 9999 }} />
            {loader && (
                <Loader/>
            )}
        </>
    )
}

export default DailyTimesheet;